import { Injectable } from '@angular/core';
import { LocalInfo } from './local-info.models';

@Injectable({
	providedIn: 'root'
})
export class LocalInfoService
{
	constructor()
	{

	}

	// =======================================
	// Init functions
	// =======================================

	// get local info
	public getLocalInfo(): LocalInfo
	{
		let _result: LocalInfo = null;

		if (!localStorage.getItem('local_info'))
		{
			const _newLocalInfo = new LocalInfo();
			localStorage.setItem('local_info', JSON.stringify(_newLocalInfo));
		}

		_result = JSON.parse(localStorage.getItem('local_info'));

		return _result;
	}

	// update local info
	public setLocalInfo(localInfo: LocalInfo): LocalInfo
	{
		localStorage.setItem('local_info', JSON.stringify(localInfo));

		return localInfo;
	}

	// remove local info
	public removeLocalInfo(): void
	{
		localStorage.removeItem('local_info');
	}

	// =======================================
	// Search filters
	// =======================================

	// save search filter
	public saveFilter(name: string, value: string)
	{
		// get current user and local info
		const _localInfo: LocalInfo = this.getLocalInfo();

		// check: filter already exists
		if (_localInfo.searchFilters.find(x => x.name === name))
			_localInfo.searchFilters.find(x => x.name === name).value = value;
		else
			_localInfo.searchFilters.push({ name: name, value: value });

		// updating local info
		this.setLocalInfo(_localInfo);
	}

	// remove search filter
	public removeFilter(name: string)
	{
		// get current user and local info
		const _localInfo: LocalInfo = this.getLocalInfo();

		// filter index
		const _filterIndex = _localInfo.searchFilters.findIndex(x => x.name === name);
		if (_filterIndex > -1)
			_localInfo.searchFilters.splice(_filterIndex, 1);

		// updating local info
		this.setLocalInfo(_localInfo);
	}

	// get search filter
	public getFilter(name: string)
	{
		// get current user and local info
		const _localInfo: LocalInfo = this.getLocalInfo();

		if (_localInfo.searchFilters.find(x => x.name === name))
			return JSON.parse(_localInfo.searchFilters.find(x => x.name === name).value);
		else
			return null;
	}
}
